import { ApiQueryKey } from '@/configs/ApiQueryKey';
import { Attachment, UUID } from '@/types/types';
import { Order } from './OrderApi';
import { UserType } from '@/types/users';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export enum ComplaintStatus {
	NEW = 'new',
	IN_PROGRESS = 'in_progress',
	ACCEPTED = 'accepted',
	REJECTED = 'rejected',
}

export interface Sender {
	email: string;
	id: UUID;
	userType: UserType;
}

export interface ComplaintMessage extends BaseEntity {
	text: string;
	sender: Sender;
}

export interface Complaint extends BaseEntity {
	number: number;
	description: string;
	attachments: Attachment[];
	status: ComplaintStatus;
	order: Order;
	messages: ComplaintMessage[];
}

class ComplaintApi extends EntityApi<Complaint> {
	constructor() {
		super(ApiQueryKey.complaints);
		this.changeStatus = this.changeStatus.bind(this);
		this.addMessage = this.addMessage.bind(this);
	}

	async changeStatus(data: { id: UUID; status: ComplaintStatus }) {
		const response = await httpClient.patch<Order>(
			`/${this.queryKey}/${data.id}/change-status`,
			{ status: data.status }
		);

		return response.data;
	}

	async addMessage({ complaintId, text }: { complaintId: UUID; text: string }) {
		const response = await httpClient.post<ComplaintMessage>(
			`${this.queryKey}/${complaintId}/messages`,
			{ text }
		);
		return response.data;
	}
}

export default new ComplaintApi();
